"use client";

import { motion } from "framer-motion";

interface IRolesBadgeGridProps {
  roles: string[];
}

export function RolesBadgeGrid({
  roles,
}: IRolesBadgeGridProps): React.ReactElement {
  return (
    <div className="flex flex-wrap justify-center gap-3">
      {roles.map((role) => (
        <motion.span
          key={role}
          className="inline-flex items-center rounded-full border border-border bg-card px-4 py-2 text-sm font-medium text-foreground"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.25 }}
          whileHover={{ y: -2 }}
        >
          {role}
        </motion.span>
      ))}
    </div>
  );
}
